export function tileRequestHeaders({
	url,
	apiToken,
}: {
	url: string
	apiToken: string | null | undefined
}): Record<string, string> {
	if (!url.includes("v3-tiles") || !apiToken) {
		return {}
	}

	return { "x-api-token": apiToken }
}
